/**
 * @generated SignedSource<<3ab5a7ba4427092eb526171e9ed9db5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleStorytellingCard_storytellingModule$data = {
  readonly backgroundColor: string | null;
  readonly ctaLink: string | null;
  readonly ctaText: string | null;
  readonly ctaType: string | null;
  readonly description: string | null;
  readonly footnoteText: string | null;
  readonly headerText: string | null;
  readonly imageUrl: string | null;
  readonly includeItem: boolean | null;
  readonly item: {
    readonly firstPhotoWebPath: string | null;
    readonly localizedPdpUrl: string | null;
    readonly title: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProductPrice_item">;
  } | null;
  readonly textColor: string | null;
  readonly " $fragmentType": "SbSharedContentModuleStorytellingCard_storytellingModule";
};
export type SbSharedContentModuleStorytellingCard_storytellingModule$key = {
  readonly " $data"?: SbSharedContentModuleStorytellingCard_storytellingModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleStorytellingCard_storytellingModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleStorytellingCard_storytellingModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "footnoteText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "small"
            }
          ],
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"small\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localizedPdpUrl",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductPrice_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StorytellingModuleItem",
  "abstractKey": null
};

(node as any).hash = "10bcd5cc28d05769b60b547b2aa99fd4";

export default node;
